import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class FileDownloadService {
  triggerDownload(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  filenameFromHeaders(headers: HttpHeaders): string | null {
    const disposition = headers.get('content-disposition');
    if (!disposition) return null;

    // Prefer the RFC 5987 extended form (filename*=UTF-8''percent%20encoded.pdf).
    // It carries the true, possibly non-ASCII name; the plain `filename` is only an
    // ASCII fallback. Capture up to the next ';' so we don't swallow other params.
    const extendedMatch = /filename\*=[^']*''([^;]+)/i.exec(disposition);
    if (extendedMatch?.[1]) {
      try {
        return decodeURIComponent(extendedMatch[1].trim());
      } catch {
        // Malformed encoding - fall through to the plain filename below.
      }
    }

    // Quoted plain filename: the closing quote terminates the value.
    const quotedMatch = /filename="([^"]*)"/i.exec(disposition);
    if (quotedMatch?.[1]) return quotedMatch[1].trim();

    // Unquoted plain filename: stop at ';' so a trailing filename* isn't captured.
    const plainMatch = /filename=([^;]+)/i.exec(disposition);
    return plainMatch?.[1]?.trim() ?? null;
  }
}
